import React, { useEffect, useState } from 'react';
import {
  Pagination,
  Tag,
  Button,
  Select,
  Modal,
  Form,
  Input,
  Upload,
  Tooltip,
  message,
} from 'antd';
import uuid from 'uuid';
import './ArrivalLandmark.css';
import { toastr } from 'react-redux-toastr';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import {
  deletePlaylist,
  fetchArrival,
  fetchArrivalInit,
} from 'state/actions/api';
import { fetchPlaylist, addPostPlaylist } from 'state/actions/playlist';
// import PlaylistPreview from 'components/PlaylistPreview';
import { imgUrl } from 'utils/url';
import { submitAddImage } from 'state/actions/api';
import PlaylistArrival from 'components/PlaylistArrival';
import moment from 'moment';

const { Option } = Select;

function ArrivalLandmark({ current }) {
  const [playlist, setPlaylist] = useState();
  const { siteId } = useParams();
  // eslint-disable-next-line
  const [search, setSearch] = useState('');
  // eslint-disable-next-line
  // const [source, setSource] = useState('all');
  const [sides, setSides] = useState('all');
  // eslint-disable-next-line
  // eslint-disable-next-line
  const [selected, setSelected] = useState([]);
  const [minValue, setMinValue] = useState(0);
  // eslint-disable-next-line
  const [maxValue, setMaxValue] = useState(8);
  // eslint-disable-next-line
  const [sizePage, setSizePage] = useState(8);
  const { CheckableTag } = Tag;
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState(0);
  const [modalUpload, setModalUpload] = useState(false);
  const [isDragged, setIsDragged] = useState(false);
  const [playlistCategory, setPlaylistCategory] = useState();
  const [media, setMedia] = useState({
    file: null,
    logo: null,
    name: '',
    name2: '',
    description: '',
  });
  const [deleteModal, setDeleteModal] = useState({
    list: [],
    isOpen: false,
  });
  // const [uploading, setUploading] = useState(false);

  const [mediaPreviewModal, setMediaPreviewModal] = useState({
    title: '',
    isOpen: false,
    source: '',
  });

  const { apiList, loading, playlistList, updated, deleted, tab } = useSelector(
    (state) => ({
      apiList: state.api.artwork,
      loading: state.api.loading,
      playlistList: state.playlist.list,
      updated: state.playlist.added,
      uploading: state.api.uploading,
      deleted: state.api.deleted,
      tab: state.tab.tab,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const category = [
    {
      type: 'artwork',
      name: 'Playlist',
    },
    {
      type: 'artwork-a',
      name: 'Playlist Staging A',
    },
    {
      type: 'artwork-b',
      name: 'Playlist Staging B',
    },
  ];

  useEffect(() => {
    if (current === 'playlist-a') {
      dispatch(fetchPlaylist({ siteId, type: 'artwork-a' }));
    } else if (current === 'playlist-b') {
      dispatch(fetchPlaylist({ siteId, type: 'artwork-b' }));
    } else {
      dispatch(fetchPlaylist({ siteId, type: 'artwork' }));
    }
  }, [current]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(fetchArrivalInit());
    dispatch(fetchArrival({ siteId }));

    // setMedias(mediaList);
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // dispatch(fetchArrival({ siteId }));
    dispatch(fetchArrival({ siteId, type: 'artwork' }));
    // setSource('all');
    setSides('all');
    // dispatch(fetchPlaylist({ siteId, type: 'artwork' }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // dispatch(fetchArrival({ siteId }));
    if (tab === 'arrival-landmark') {
      dispatch(fetchArrival({ siteId, type: 'artwork' }));
      // setSource('all');
      setSides('all');
      dispatch(fetchPlaylist({ siteId, type: 'artwork' }));
      // dispatch(fetchPlaylistStaging({ siteId, type: 'artwork-staging' }));
    }
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (deleted && !loading) {
      setDeleteModal((prevState) => ({
        ...prevState,
        list: [],
        isOpen: false,
      }));
    }
  }, [deleted, loading]);

  useEffect(() => {
    if (current === 'search') dispatch(fetchArrival({ siteId }));
    // setSource('all');
    setSides('all');
    setPlaylist();
  }, [current]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSearch();
  }, [playlist]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSearch();
    setSelected([]);
  }, [updated]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setCurrentPage(1);
    setMinValue(0);
    setMaxValue(sizePage);
    // setMedias(mediaList);
  }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setMaxValue(minValue + sizePage);
  }, [sizePage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (playlistCategory) {
      dispatch(fetchPlaylist({ siteId, type: playlistCategory }));
      setPlaylist();
    }
  }, [playlistCategory]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangePage = (value) => {
    setCurrentPage(value);
    if (value <= 1) {
      setMinValue(0);
      setMaxValue(sizePage);
    } else {
      setMinValue(value * sizePage - sizePage);
      setMaxValue(value * sizePage);
    }
  };
  const onAddImages = (img, checked) => {
    if (checked) {
      setSelected([...selected, img]);
    } else {
      const index = selected.indexOf(img);
      selected.splice(index, 1);
      setSelected([...selected]);
    }
  };

  const onPreviewMediaClickHandler = (post) => {
    setMediaPreviewModal((prevState) => ({
      ...prevState,
      isOpen: true,
      image_url: post.image_url ?? '',
      video_url:
        post.video_url ??
        (post.image_url &&
          post.image_url.slice(-3) === 'mp4' &&
          post.image_url) ??
        '',
      title: post.al_name,
      description: post.description,
      qr_code: post.qr_code,
      qr_code_position: post.qr_code_position,
      start_date: post.start_date,
      end_date: post.end_date,
    }));
  };

  const onSearch = (e) => {
    setSearch(e.target.value);
  };
  var data = search
    ? apiList.filter((el) => {
        const clonedElem = { ...el };
        const name =
          clonedElem.coi_name &&
          clonedElem.coi_name.toLowerCase().includes(search.toLowerCase());
        const desc = clonedElem.description
          .toLowerCase()
          .includes(search.toLowerCase());
        if (name || desc) {
          return clonedElem;
        }
        return false;
      })
    : apiList;
  data =
    sides && sides !== 'all'
      ? data.filter((el) => {
          const clonedElem = { ...el };
          if (clonedElem.no_of_sides) {
            return clonedElem.no_of_sides.toString() === sides;
          }
          return false;
        })
      : data;

  const onShowSizeChange = (current, pageSize) => {
    setCurrentPage(current);
    setSizePage(pageSize);
  };
  // const trimString = (string, length) => {
  //   return string.length > length
  //     ? `${string.substring(0, length)}...`
  //     : string;
  // };

  const onAddToPlaylist = () => {
    if (!playlist) {
      toastr.error('', 'Choose the playlist');
    }
    if (selected.length < 1) {
      toastr.error('', 'Choose images');
    }
    if (playlist && selected.length > 0) {
      const post = [...playlist.posts];
      selected.map((art) =>
        post.push(
          art.image_url
            ? {
                id: uuid(),
                name: art.coi_name ?? art.name,
                description: art.description ?? '',
                image_url: art.image_url,
                ...art,
              }
            : {
                id: uuid(),
                name: art.name,
                description: art.description,
                video_url: art.video_url,
              }
        )
      );
      playlist.posts = post;
      dispatch(
        addPostPlaylist({
          playlist,
          access: 'arrival_landmark',
          action: 'update',
          message: 'add_post',
        })
      );
    }
  };

  const imagePreviewUrl = media.file
    ? media.file && URL.createObjectURL(media.file)
    : media.logo && `${imgUrl}/media/${media.logo}`;

  const onFileChangedHandler = (file) => {
    if (
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'video/mp4'
    ) {
      if (file.size / 1000000 <= 50) {
        setMedia((prevState) => ({ ...prevState, file, logo: null }));
      } else {
        message.error('Maximum file size is 50MB');
      }
    } else {
      message.error('Unsupported filetype!');
    }
    setIsDragged(false);
  };

  const handleDeletePreviewImage = () => {
    setMedia((prevState) => ({ ...prevState, file: null, logo: null }));
  };

  const handleChange = (name, value) => {
    setMedia({
      ...media,
      [name]: value,
    });
  };

  const handleReset = () => {
    setModalUpload(false);
    setMedia({
      file: null,
      logo: null,
      name: '',
      description: '',
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  };

  const hidePreviewModal = () => {
    setMediaPreviewModal((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  };

  const onDeleteItemHandler = () => {
    dispatch(deletePlaylist({ list: deleteModal.list }));
  };

  const handleSubmit = () => {
    if (media.name && media.description && media.file) {
      dispatch(submitAddImage({ media, siteId }));
    }
  };

  return (
    <div className="media__library">
      <Modal
        title="Upload custom media"
        visible={modalUpload}
        className="media-form"
        onCancel={handleReset}
        okText="Submit"
        onOk={handleSubmit}
        okButtonProps={{
          loading,
        }}
        cancelButtonProps={{
          hidden: loading,
        }}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          layout="horizontal"
        >
          <Form.Item
            label="Name"
            rules={[{ required: true, message: 'Name is required!' }]}
          >
            <Input
              placeholder="Name"
              onChange={(e) => handleChange('name', e.target.value)}
              value={media.name}
            />
          </Form.Item>
          <Form.Item
            label="Description"
            rules={[{ required: true, message: 'Description is required' }]}
          >
            <Input.TextArea
              placeholder="Description"
              rows={6}
              onChange={(e) => handleChange('description', e.target.value)}
              value={media.description}
            />
          </Form.Item>
          <Form.Item label="Upload" required>
            {imagePreviewUrl ? (
              <div className="upload-image-preview">
                <Tooltip placement="top" title="Delete">
                  <button
                    type="button"
                    onClick={handleDeletePreviewImage}
                    className="btn-remove"
                  >
                    <i className="feather-x" />
                  </button>
                </Tooltip>
                {(media.file && media.file.type === 'video/mp4') ||
                (media.fileType === 'video/mp4' && !media.file) ? (
                  <video
                    controls="controls"
                    preload="metadata"
                    key={imagePreviewUrl}
                  >
                    <source src={imagePreviewUrl} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    className="media-avatar"
                    src={imagePreviewUrl}
                    alt="User profile logo preview"
                  />
                )}
              </div>
            ) : (
              <Upload
                showUploadList={false}
                beforeUpload={onFileChangedHandler}
              >
                <div
                  onDragLeave={() => setIsDragged(false)}
                  onDragOver={() => setIsDragged(true)}
                  className={`upload-drag-and-drop ${
                    isDragged ? 'active' : ''
                  }`}
                >
                  <i className="feather-upload" />
                  <p>Drag or click to upload</p>
                </div>
              </Upload>
            )}
          </Form.Item>
        </Form>
      </Modal>
      {/* </div> */}

      {deleteModal.isOpen && (
        <Modal
          title="Are you sure to delete this item?"
          visible={deleteModal.isOpen}
          onOk={onDeleteItemHandler}
          onCancel={onCloseModalHandler}
        >
          Are you sure to delete this item?
        </Modal>
      )}

      {mediaPreviewModal.isOpen && (
        <Modal
          title={null}
          visible={mediaPreviewModal.isOpen}
          footer={null}
          onCancel={hidePreviewModal}
          className="custom-modal"
        >
          {mediaPreviewModal.video_url ? (
            <video id="my-video" className="video-js" data-setup="{}" controls>
              <source src={mediaPreviewModal.video_url} />
            </video>
          ) : mediaPreviewModal.image_url ? (
            <img src={mediaPreviewModal.image_url} alt="post" />
          ) : null}

          <div className="custom-modal-content">
            <div className="custom-modal-content-title">
              <div className="custom-modal-title">Title</div>
              <div className="custom-modal-description">
                {mediaPreviewModal.title ? mediaPreviewModal.title : 'No Title'}
              </div>
            </div>
            <div className="custom-modal-content-title">
              <div className="custom-modal-title">Description</div>
              <div className="custom-modal-description">
                {mediaPreviewModal.description}
              </div>
            </div>
            {mediaPreviewModal.qr_code && (
              <div className="custom-modal-content-title">
                <div className="custom-modal-title">QR code url</div>
                <div className="custom-modal-description">
                  {mediaPreviewModal.qr_code}
                </div>
              </div>
            )}
            {mediaPreviewModal.qr_code_position && (
              <div className="custom-modal-content-title">
                <div className="custom-modal-title">QR code position</div>
                <div className="custom-modal-description">
                  {mediaPreviewModal.qr_code_position}
                </div>
              </div>
            )}
            {mediaPreviewModal.start_date && (
              <div className="custom-modal-content-title">
                <div className="custom-modal-title">Date</div>
                <div className="custom-modal-description">
                  {moment(mediaPreviewModal.start_date).format(
                    'YYYY-MM-DD HH:mm'
                  )}{' '}
                  -
                  {moment(mediaPreviewModal.end_date).format(
                    'YYYY-MM-DD HH:mm'
                  )}
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {current === 'search' && (
        <div className="media-header-arrival">
          <div className="media-header-input">
            <div className="media-header-left">
              <div className="media-form-group">
                <label>Search</label>
                <div className="searchbar">
                  <i className="feather-search" />
                  <input
                    placeholder="Search..."
                    className="search-input"
                    value={search}
                    onChange={onSearch}
                  />
                </div>
              </div>
            </div>
            <div className="media-header-right">
              <div className="media-form-group">
                <label>Filter by sides</label>
                <Select
                  className="select-dropdown-item"
                  defaultValue="all"
                  onChange={(e) => setSides(e)}
                >
                  <Option value={'all'}>All</Option>
                  <Option value={'1'}>1</Option>
                  <Option value={'2'}>2</Option>
                  <Option value={'3'}>3</Option>
                  <Option value={'4'}>4</Option>
                </Select>
              </div>
              <div className="media-form-group">
                <label>Select Playlist</label>
                <Select
                  className="select-dropdown-item"
                  defaultValue="Select Playlist Group"
                  onChange={(e) => setPlaylistCategory(e)}
                >
                  {category.map((playlist, index) => (
                    <Option key={index} value={playlist.type}>
                      {playlist.name}
                    </Option>
                  ))}
                </Select>
              </div>
              {playlistCategory && (
                <div className="media-form-group">
                  <Select
                    className="select-dropdown-item"
                    defaultValue="Select Playlist"
                    onChange={(e) => setPlaylist(playlistList[e])}
                  >
                    {playlistList &&
                      playlistCategory &&
                      playlistList.map((playlist, index) => (
                        <Option key={playlist._id} value={index}>
                          {playlist.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              )}
            </div>
          </div>
          <div className="media-header-input">
            <Button
              type="primary"
              className="btn-primary"
              onClick={onAddToPlaylist}
            >
              Add to playlist
            </Button>
          </div>
        </div>
      )}

      <div className="media__content">
        {current === 'search' ? (
          <>
            {loading ? (
              <ClipLoader />
            ) : (
              <>
                <div className="media__list">
                  <>
                    {data.length > 0 && (
                      <>
                        {data.slice(minValue, maxValue).map((api, index) => {
                          return (
                            <div key={index} className="media__item">
                              <div className="media__item-actions">
                                <Tooltip
                                  title="Media Preview"
                                  className="media__preview"
                                >
                                  <button
                                    onClick={() => {
                                      onPreviewMediaClickHandler(api);
                                    }}
                                  >
                                    <i className="feather-maximize-2" />
                                  </button>
                                </Tooltip>
                              </div>

                              <div className="img-label-wrapper">
                                <div className="img-label-2">
                                  {api.landmark_no
                                    ? `AL ${api.landmark_no}`
                                    : 'Arrival Landmark'}
                                </div>
                              </div>

                              <CheckableTag
                                checked={selected.indexOf(api) !== -1}
                                onChange={(checked) =>
                                  onAddImages(api, checked)
                                }
                              >
                                {selected.indexOf(api) !== -1 && (
                                  <div className="checked-overlay">
                                    <svg
                                      width="24"
                                      height="18"
                                      viewBox="0 0 24 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="icon-checked"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M23.6095 1.05719C24.1302 1.57789 24.1302 2.42211 23.6095 2.94281L8.94281 17.6095C8.42211 18.1302 7.57789 18.1302 7.05719 17.6095L0.390524 10.9428C-0.130175 10.4221 -0.130175 9.57789 0.390524 9.05719C0.911223 8.53649 1.75544 8.53649 2.27614 9.05719L8 14.7811L21.7239 1.05719C22.2446 0.536493 23.0888 0.536493 23.6095 1.05719Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                )}

                                {(api.image_url &&
                                  api.image_url.slice(-3) !== 'mp4') ||
                                (api.url && api.ext !== 'video/mp4') ? (
                                  <img
                                    className="media__item-img"
                                    src={api.image_url}
                                    alt=""
                                  />
                                ) : (
                                  <video
                                    id="my-video"
                                    className="video-js"
                                    data-setup="{}"
                                    preload="metadata"
                                  >
                                    <source
                                      src={
                                        api.video_url
                                          ? api.video_url
                                          : api.image_url
                                      }
                                    />
                                  </video>
                                )}
                                <div className="media__item-description">
                                  <span>
                                    {(api.al_name ? api.al_name : api.name) ??
                                      'No title'}
                                  </span>
                                  {api.start_date && api.end_date && (
                                    <p>
                                      {moment(api.start_date).format(
                                        'YYYY-MM-DD HH:mm'
                                      )}{' '}
                                      -
                                      {moment(api.end_date).format(
                                        'YYYY-MM-DD HH:mm'
                                      )}
                                    </p>
                                  )}
                                </div>
                              </CheckableTag>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </>
                </div>
              </>
            )}
          </>
        ) : (
          <PlaylistArrival
            playlists={playlistList}
            apiList={apiList}
            updated={updated}
            access="arrival_landmark"
          ></PlaylistArrival>
        )}
      </div>

      {current === 'search' && (
        <>
          <div className="media-pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              total={data.length}
              pageSize={sizePage}
              onChange={handleChangePage}
              onShowSizeChange={onShowSizeChange}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default ArrivalLandmark;
